module.exports = __webpack_public_path__ + "static/media/avatorIcon.a9b27ca6.svg";